<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M16.2 13.6H3.6q-.7 0-1.1-.5T2 12t.5-1.1q.4-.5 1-.5h12.7L11 5.2q-.5-.5-.5-1.1T11 3t1.1-.5q.8 0 1.2.5l7.9 7.9.4 1a2 2 0 0 1-.4 1.2l-8 8q-.4.3-1 .4-.7 0-1.2-.5t-.5-1.1.5-1.1z"
    />
  </svg>
</template>
